import { render, staticRenderFns } from "./DatabaseWarning.vue?vue&type=template&id=91f43658&scoped=true"
import script from "./DatabaseWarning.vue?vue&type=script&lang=js"
export * from "./DatabaseWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f43658",
  null
  
)

export default component.exports